import React from "react";
import {ActionIcon, Avatar, Badge, Button, Flex, Grid, rem, Text} from "@mantine/core";
import {IconChevronRight} from "@tabler/icons-react";

export default function PersonCardHeader() {
    return (
        <Grid p={rem(12)}>
            <Grid.Col span={3} pr={rem(15)}>
                <Text
                    c={'#6F767E'}
                    fw={700}
                    fz={rem(13)}
                    lh={rem(16)}>
                    Name
                </Text>
            </Grid.Col>
            <Grid.Col span={6} px={rem(15)}>
                <Grid>
                    <Grid.Col span={2}>
                        <Text
                            c={'#6F767E'}
                            fw={700}
                            fz={rem(13)}
                            lh={rem(16)}>
                            Wait Days
                        </Text>
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <Text
                            c={'#6F767E'}
                            fw={700}
                            fz={rem(13)}
                            lh={rem(16)}>
                            Age
                        </Text>
                    </Grid.Col>
                    <Grid.Col span={5}>
                        <Text
                            c={'#6F767E'}
                            fw={700}
                            fz={rem(13)}
                            lh={rem(16)}>
                            Sched.
                        </Text>
                    </Grid.Col>
                    <Grid.Col span={3}>
                        <Text
                            c={'#6F767E'}
                            fw={700}
                            fz={rem(13)}
                            lh={rem(16)}>
                            Gender
                        </Text>
                    </Grid.Col>
                </Grid>
            </Grid.Col>
            <Grid.Col span={2} px={rem(15)}>
                <Text
                    c={'#6F767E'}
                    fw={700}
                    fz={rem(13)}
                    lh={rem(16)}>
                    Volunteer Matches
                </Text>
            </Grid.Col>
            <Grid.Col span={1} pl={rem(15)}>
                <Text
                    c={'#6F767E'}
                    fw={700}
                    fz={rem(13)}
                    lh={rem(16)}>
                    More
                </Text>
            </Grid.Col>
        </Grid>
    )
}